import isClientSide from "../../common-utils/environment/isClientSide.util.js";
/**
 * Checks whether the code is running on the server (Node.js) side.
 * @returns boolean
 */
export const isServerSideUtil = () => !isClientSide();
export default isServerSideUtil;
